import * as React from 'react';

import { useBoolean, useLockFn } from 'ahooks';
import { Button, notification, Typography } from 'antd';

import { useLoginAction, useLoginValue } from 'context';
import { useTimer } from 'hooks';
import { sendSigninOtp } from 'services';
import { createTimestamp, padString } from 'utils';

const defaultTimestamp = 2.5 * 60 * 1000;

const LoginExpirationPinTime = () => {
  const [loading, { toggle: toggleLoading }] = useBoolean();
  const { isRunning, seconds, minutes, restart } = useTimer({
    targetDate: createTimestamp(defaultTimestamp),
  });
  const { phoneNumber } = useLoginValue();
  const action = useLoginAction();

  const resendSigninOtp = useLockFn(async () => {
    if (phoneNumber) {
      toggleLoading();

      sendSigninOtp({ phoneNumber })
        .then(({ ticket }) => {
          restart(createTimestamp(defaultTimestamp));
          action({
            type: 'UPDATE_LOGIN_IDENTITY',
            payload: { phoneNumber, ticket },
          });
        })
        .catch(message => {
          notification.error({ message });
        })
        .finally(() => {
          toggleLoading();
        });
    }
  });

  if (isRunning) {
    return (
      <Typography.Paragraph>
        <span>درخواست مجدد تا </span>
        <time>
          {padString(minutes.toString())}:{padString(seconds.toString())}
        </time>
      </Typography.Paragraph>
    );
  }

  return (
    <Button
      type='link'
      className='-mt-2'
      loading={loading}
      onClick={resendSigninOtp}
    >
      درخواست مجدد
    </Button>
  );
};

export { LoginExpirationPinTime };
